// extracted by mini-css-extract-plugin
export var subtitle = "_7i-2";
export var title = "_7i-0";
export var titleNoWrap = "_7i-1";